import {Fragment, useEffect, useState} from "react";
import {
    Autocomplete,
    FormControl,
    FormLabel,
    Grid,
    InputAdornment,
    MenuItem,
    Select,
    TextField,
    Typography
} from "@mui/material";
import {green} from "../../Utils/style";
import {makeStyles} from "@mui/styles";

const linearRatioType = ['5', '6', '7', '8', '9', '10', '11', '12']

const useStyles = makeStyles({
    smallInput: {
        "& .MuiInputBase-input": {
            height: "0px", // Adjust the height as per your preference
            padding: "2px", // Adjust the padding as per your preference
            fontSize: "14px", // Adjust the font size as per your preference
        }
    }
})

export const WordPressCalculatorPallet = ({lng, validatedResult, cbHandlePalletDetail}) => {

    const classes = useStyles();

    const [palletDetail, setPalletDetail] = useState({
            metric: false,
            length: '48',
            width: '40',
            height: '60',
            weight: '400',
            lengthUnit: 'in',
            weightUnit: 'lb',
            quantity: "1",
            linearRatio: '9'
        }
    );

    const handleLength = (event) => {
        const {value} = event?.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setPalletDetail(prevState => ({
                ...prevState,
                length: value
            }))
        }
    }

    const handleWidth = (event) => {
        const {value} = event?.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setPalletDetail(prevState => ({
                ...prevState,
                width: value
            }))
        }
    }

    const handleHeight = (event) => {
        const {value} = event?.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setPalletDetail(prevState => ({
                ...prevState,
                height: value
            }))
        }
    }

    const handleWeight = (event) => {
        const {value} = event?.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setPalletDetail(prevState => ({
                ...prevState,
                weight: value
            }))
        }
    }

    const handleQuantity = (event) => {
        const {value} = event.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setPalletDetail(prevState => ({
                ...prevState,
                quantity: value
            }))
        }
    }

    const handleLinearRatio = (event, value) => {
        setPalletDetail(prevState => ({
            ...prevState,
            linearRatio: value
        }))
    }

    const handleMetric = (event) => {
        const {value} = event.target;
        setPalletDetail(prevState => ({
            ...prevState,
            metric: value
        }))
    }

    useEffect(() => {
        cbHandlePalletDetail(palletDetail);
    }, [palletDetail])

    console.log('[WordPressCalculatorPallet] palletDetail', palletDetail);

    return (
        <Fragment>
            <Grid size={{xs: 12, md: 1.75}}>
                <FormControl fullWidth>
                    <FormLabel required>
                        {lng === 'cn' ? '长度' : 'Length'}
                    </FormLabel>
                    <TextField
                        value={palletDetail?.length}
                        onInput={handleLength}
                        size='small'
                        type='number'
                        sx={{
                            '& .MuiInputBase-root': {  // Targets the root input container
                                height: 33,  // Set custom height (default small is ~36px)
                                fontSize: '14px',  // Consistent font size
                            },
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    {palletDetail?.lengthUnit}
                                </InputAdornment>
                            ),
                            style: {fontSize: 14}
                        }}
                        error={validatedResult !== null && (+palletDetail?.length <= 0 || !palletDetail?.length)}
                        helperText={validatedResult !== null && (!palletDetail?.length ? (lng === 'cn' ? "必填" : "Required") : +palletDetail?.length <= 0 && (lng === 'cn' ? "无效" : "Invalid"))}
                    />
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: 1.75}}>
                <FormControl fullWidth>
                    <FormLabel required>
                        {lng === 'cn' ? '宽度' : 'Width'}
                    </FormLabel>
                    <TextField
                        value={palletDetail?.width}
                        onInput={handleWidth}
                        size='small'
                        type='number'
                        sx={{
                            '& .MuiInputBase-root': {  // Targets the root input container
                                height: 33,  // Set custom height (default small is ~36px)
                                fontSize: '14px',  // Consistent font size
                            },
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    {palletDetail?.lengthUnit}
                                </InputAdornment>
                            ),
                            style: {fontSize: 14}
                        }}
                        error={validatedResult !== null && (+palletDetail?.width <= 0 || !palletDetail?.width)}
                        helperText={validatedResult !== null && (!palletDetail?.width ? (lng === 'cn' ? "必填" : "Required") : +palletDetail?.width <= 0 && (lng === 'cn' ? "无效" : "Invalid"))}
                    />
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: 1.75}}>
                <FormControl fullWidth>
                    <FormLabel required>
                        {lng === 'cn' ? '高度' : 'Height'}
                    </FormLabel>
                    <TextField
                        value={palletDetail?.height}
                        onInput={handleHeight}
                        size='small'
                        type='number'
                        sx={{
                            '& .MuiInputBase-root': {  // Targets the root input container
                                height: 33,  // Set custom height (default small is ~36px)
                                fontSize: '14px',  // Consistent font size
                            },
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    {palletDetail?.lengthUnit}
                                </InputAdornment>
                            ),
                        }}
                        error={validatedResult !== null && (+palletDetail?.height <= 0 || !palletDetail?.height)}
                        helperText={validatedResult !== null && (!palletDetail?.height ? (lng === 'cn' ? "必填" : "Required") : +palletDetail?.height <= 0 && (lng === 'cn' ? "无效" : "Invalid"))}
                    />
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: 1.75}}>
                <FormControl fullWidth>
                    <FormLabel required>
                        {lng === 'cn' ? '重量' : 'Weight'}
                    </FormLabel>
                    <TextField
                        value={palletDetail?.weight}
                        onInput={handleWeight}
                        size='small'
                        type='number'
                        sx={{
                            '& .MuiInputBase-root': {  // Targets the root input container
                                height: 33,  // Set custom height (default small is ~36px)
                                fontSize: '14px',  // Consistent font size
                            },
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    {palletDetail?.weightUnit}
                                </InputAdornment>
                            ),
                            style: {fontSize: 14}
                        }}
                        error={validatedResult !== null && (+palletDetail?.weight <= 0 || !palletDetail?.weight)}
                        helperText={validatedResult !== null && (!palletDetail?.weight ? (lng === 'cn' ? "必填" : "Required") : +palletDetail?.weight <= 0 && (lng === 'cn' ? "无效" : "Invalid"))}
                    />
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: 1.75}}>
                <FormControl fullWidth>
                    <FormLabel required>
                        {lng === 'cn' ? '线性比例' : 'Linear Ratio'}
                    </FormLabel>
                    <Autocomplete
                        value={palletDetail?.linearRatio}
                        fullWidth
                        options={linearRatioType}
                        getOptionLabel={option => option}
                        onChange={handleLinearRatio}
                        renderInput={(params) => <TextField
                            variant="outlined"
                            {...params}
                            className={classes.smallInput}
                            error={validatedResult !== null && (+palletDetail?.linearRatio <= 0 || !palletDetail?.linearRatio)}
                            helperText={validatedResult !== null && (!palletDetail?.linearRatio ? (lng === 'cn' ? "必填" : "Required") : +palletDetail?.linearRatio <= 0 && (lng === 'cn' ? "无效" : "Invalid"))}
                        />}
                        renderOption={(props, option) => (
                            <li {...props}>
                                <Typography style={{fontSize: '12px'}}>
                                    {option}
                                </Typography>
                            </li>
                        )}
                    />
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: 1.5}}>
                <Typography
                    sx={{
                        display: 'flex',
                        alignItems: 'flex-end',
                        height: '100%',
                        fontSize: '30px',
                        fontWeight: '600',
                        color: green,
                        justifyContent: 'center'
                    }}>
                    X
                </Typography>
            </Grid>
            <Grid size={{xs: 12, md: 1.75}}>
                <FormControl fullWidth>
                    <FormLabel required>
                        {lng === 'cn' ? '数量' : 'Quantity'}
                    </FormLabel>
                    <TextField
                        value={palletDetail?.quantity}
                        onInput={handleQuantity}
                        size='small'
                        type='number'
                        sx={{
                            '& .MuiInputBase-root': {  // Targets the root input container
                                height: 33,  // Set custom height (default small is ~36px)
                                fontSize: '14px',  // Consistent font size
                            },
                        }}
                        error={validatedResult !== null && (+palletDetail?.quantity <= 0 || !palletDetail?.quantity)}
                        helperText={validatedResult !== null && (!palletDetail?.quantity ? (lng === 'cn' ? "必填" : "Required") : +palletDetail?.quantity <= 0 && (lng === 'cn' ? "无效" : "Invalid"))}
                    />
                </FormControl>
            </Grid>
        </Fragment>
    )
}